import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { PartTypeListComponent } from './components/part-type-list/part-type-list.component';

export class PartTypeRoutingStates {
  public static readonly LIST = {
    url: 'part-type'
  };
}

export const PartTypeRoutes: Routes = [
  {
    path: PartTypeRoutingStates.LIST.url,
    data: {
      page: {
        title: 'Part Type'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR]
    },
    component: PartTypeListComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(PartTypeRoutes)]
})
export class PartTypeRoutingModule {}
